import { render, staticRenderFns } from "./GiftCodeWidget.vue?vue&type=template&id=2b810c74"
import script from "./GiftCodeWidget.vue?vue&type=script&lang=js"
export * from "./GiftCodeWidget.vue?vue&type=script&lang=js"
import style0 from "./GiftCodeWidget.vue?vue&type=style&index=0&id=2b810c74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports